const allmanagers = { data: [], loading: true };
export const GetallManagersReducer = (state = allmanagers, action) => {
  switch (action.type) {
    case "get_allmanager":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
